import PropTypes from 'prop-types';
import styled from 'styled-components';
import { getTranslation } from '../../../translations/translations';
import LazyLoadedImage from '../../LazyLoadedImage/LazyLoadedImage';
import PrdStickers from '../../PrdStickers/PrdStickers';

const LabelOnlineOnly = styled.span`
  display: inline-block;
  margin: 2px 0;
  box-sizing: inherit;
  color: #954b22;
  line-height: normal;
  font-size: 12px;
  border: 1px solid #909090;
  background: #fff;
  white-space: nowrap;
  text-transform: uppercase;
  padding: 2px 42px;

  .resultList & {
    max-width: 191px;
  }

  .resultGrid & {
    width: 100%;
    padding: 2px 0px;
  }

  .product & {
    margin-top: 0;
  }
`;

const DivRad = styled.div`
  margin: 0 0 10px;
  font-size: 13px;
  color: #000;

  img {
    display: inline-block;
    vertical-align: middle;
    margin-right: 5px;
  }

  i {
    font-size: 18px;
  }

  &:hover {
    color: inherit;
  }
`;

const ListItemPromoMessages = ({ promoMessages, preOrder, loadImagesLazily }) => (
  <>
    {promoMessages.isOnlineOnly && (
      <LabelOnlineOnly className={'label-online-only'}>
        {getTranslation('onlineOnlyTranslation')}
      </LabelOnlineOnly>
    )}

    {promoMessages.badges && (
      <PrdStickers className={'prd-stickers'}>
        {promoMessages.badges.map((sticker, i) =>
          (loadImagesLazily ? (
            // eslint-disable-next-line react/no-array-index-key
            <LazyLoadedImage key={i} src={sticker.src} alt={sticker.label} />
          ) : (
            // eslint-disable-next-line react/no-array-index-key
            <img key={i} src={sticker.src} alt={sticker.label} />
          ))
        )}
      </PrdStickers>
    )}
    {preOrder.available && (
      <DivRad className={'rad'}>
        <i className={'dcg-icon-clock'} />
        {/* TODO: add to translations */}
        <strong>
          Available
          {/\d+\/\d+\/\d+/.test(preOrder.message)
            ? `\u00A0-\u00A0${preOrder.message}`
            : ' for pre-order'}
        </strong>
      </DivRad>
    )}
    {promoMessages.marketingMessages && promoMessages.marketingMessages[0] && (
      <DivRad className={'rad'}>
        <i className={`dcg-icon-${promoMessages.marketingMessages[0].class}`} />
        <strong
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: promoMessages.marketingMessages[0].text }}
        />
      </DivRad>
    )}
  </>
);

ListItemPromoMessages.propTypes = {
  promoMessages: PropTypes.shape({
    dealsAvailable: PropTypes.arrayOf(PropTypes.object),
    isOnlineOnly: PropTypes.bool.isRequired,
    marketingMessages: PropTypes.arrayOf(
      PropTypes.shape({
        class: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired
      }).isRequired
    ),
    numberOfDealsAvailableTranslation: PropTypes.string,
    badges: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        src: PropTypes.string.isRequired
      })
    )
  }).isRequired,
  preOrder: PropTypes.shape({
    available: PropTypes.bool.isRequired,
    message: PropTypes.string
  }).isRequired,
  loadImagesLazily: PropTypes.bool
};

ListItemPromoMessages.defaultProps = {
  loadImagesLazily: false
};

export default ListItemPromoMessages;
